// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"21":"2125c778","41":"e23625c3","130":"3ef76d1d","329":"fc561b5c","337":"5ada0026","419":"d75e57ee","453":"e3d86e0f","576":"05c0b1aa","696":"8ff22c43","918":"5b3e0a9c","970":"a9be745e"}[chunkId] + ".chunk.js";
};